import { db } from '../database/db'
import authService from './authService'

class ManagerService {
  getCurrentShopId() {
    return authService.getShopId()
  }

  getCurrentManagerId() {
    const tokenInfo = authService.getTokenInfo()
    return tokenInfo?.managerId || null
  }

  getCurrentManagerRole() {
    const tokenInfo = authService.getTokenInfo()
    return tokenInfo?.role || 'owner'
  }

  getCurrentManagerPermissions() {
    const tokenInfo = authService.getTokenInfo()
    return tokenInfo?.permissions || this.getDefaultOwnerPermissions()
  }

  getDefaultOwnerPermissions() {
    return {
      viewDashboard: true,
      viewProducts: true,
      //   addProduct: true,
      //   editProduct: true,
      //   deleteProduct: true,
      viewPurchases: true,
      //   addPurchase: true,
      //   editPurchase: true,
      //   deletePurchase: true,
      exportData: true,
      //   viewSettings: true,
    }
  }

  // CRUD Local (IndexedDB)
  async addManagerLocal(managerData) {
    try {
      const shopId = this.getCurrentShopId()
      if (!shopId) throw new Error('Session invalide')

      const manager = {
        ...managerData,
        shopId,
        isActive: true,
        createdAt: new Date().toISOString(),
      }

      const id = await db.managers.add(manager)
      return { success: true, id }
    } catch (error) {
      console.error('Erreur ajout gérant local:', error)
      return { success: false, error: error.message }
    }
  }

  async updateManagerLocal(id, managerData) {
    try {
      const manager = await db.managers.where('_id').equals(id).first()
      if (!manager) {
        return { success: false, error: 'Gérant introuvable' }
      }

      await db.managers.update(manager.id, {
        ...managerData,
        updatedAt: new Date().toISOString(),
      })
      return { success: true }
    } catch (error) {
      console.error('Erreur modification gérant local:', error)
      return { success: false, error: error.message }
    }
  }

  async getManagersLocal() {
    try {
      const shopId = this.getCurrentShopId()
      if (!shopId) return []

      return await db.managers
        .where('shopId')
        .equals(shopId)
        .and((m) => m.isActive === true)
        .toArray()
    } catch (error) {
      console.error('Erreur chargement gérants local:', error)
      return []
    }
  }

  async deleteManagerLocal(id) {
    try {
      const manager = await db.managers.where('_id').equals(id).first()
      if (!manager) {
        return { success: false, error: 'Gérant introuvable' }
      }

      await db.managers.delete(manager.id)
      return { success: true }
    } catch (error) {
      console.error('Erreur suppression gérant local:', error)
      return { success: false, error: error.message }
    }
  }

  // Vérification des permissions
  hasPermission(permission) {
    if (permission === 'viewSettings') {
      return true
    }
    const permissions = this.getCurrentManagerPermissions()
    return permissions[permission] === true
  }

  canAccessTab(tabName) {
    const permissions = this.getCurrentManagerPermissions()

    switch (tabName) {
      case 'dashboard':
        return permissions.viewDashboard
      case 'products':
        return permissions.viewProducts
      case 'purchases':
        return permissions.viewPurchases
      case 'settings':
        return permissions.viewSettings
      default:
        return false
    }
  }

  // Filtrage des données selon permissions pour l'export
  filterExportData(data) {
    const permissions = this.getCurrentManagerPermissions()
    const filtered = { ...data }

    if (!permissions.viewProducts) {
      filtered.products = []
    }

    if (!permissions.viewPurchases) {
      filtered.purchases = []
    }

    return filtered
  }
}

export default new ManagerService()
